const documentWidth = () =>
  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const isViewMobile = () => documentWidth() <= 415;

export default isViewMobile;
